import scrollTo from "./scrollTo";

const onClickCTAScrollTo = (id) => (e) => {
  if (id && typeof window === "object") {
    e.preventDefault();
    scrollTo(id);

    // we have many elements lazy loaded. Firstly they have height of 0.
    // While scrolling down to the end of the page they get loaded and get real height, what increases the page height
    // and the scroll ends up in wrong place
    // so we scroll again
    setTimeout(() => {
      scrollTo(id);
    }, 900);
    // we have many elements lazy loaded. Firstly they have height of 0.
    // While scrolling down to the end of the page they get loaded and get real height, what increases the page height
    // and the scroll ends up in wrong place
    // so we scroll again
    setTimeout(() => {
      scrollTo(id);
    }, 1600);
  }
};

export default onClickCTAScrollTo;
